<script>
	import {push,replace} from "svelte-spa-router";
	import Controlador from "../controlador.svelte";
	import {onMount} from "svelte";
	import {docs,logueo} from "../store.js";

	export let params = {id:"agregar",categoria:-1};
	let c;
	let nombre = "",costo,precio;
	let categorias = [];
	let tipo = 0;
	let alerta = 0;
	let categoria = "";
	function prod(){
		tipo = 0;
	}
	function serv(){
		tipo = 1;
	}
	function sinAlerta(){
		alerta = 0;
	}
	function conAlerta(){
		alerta = 1;
	}
	function agregar(){
		let fecha = Date.now();
		if (tipo == 0 && params.id == "agregar"){
			c.agregarDeposito({
				fecha: fecha,
				nombre: nombre.trim(),
				tipo: "Producto",
				costo: parseInt(costo, 10),
				categoria:categoria,
				precio: parseInt(precio, 10),
				alerta: alerta
			})
		} else if (tipo == 1 && params.id == "agregar") {
			c.agregarDeposito({
				fecha: fecha,
				nombre: nombre.trim(),
				tipo: "Servicio"
			})
		} else if (params.id != "agregar"){
			if (tipo == 0){
				c.editarDeposito(elm,{
					nombre: nombre.trim(),
					costo: parseInt(costo, 10),
					tipo: elm.tipo,
					precio: parseInt(precio, 10),
					alerta: alerta,
					categoria:categoria
				})
			} else {
				c.editarDeposito(elm,{
					nombre:nombre.trim(),
					tipo:elm.tipo
				})
			}
		}
		push(`/deposito/${(params.categoria==-1?"":params.categoria)}`);
	}
	let elm;
	let clase = [
		"w-full p-2 cursor-pointer flex items-center justify-center h-full bg-red-500 text-white",
		"w-full p-2 cursor-pointer flex items-center justify-center h-full bg-gray-500"
	];
	onMount(()=>{
		console.log(params);
		categorias = $docs.find((el)=>el._id == "config:categorias").categorias;
		if (params.categoria != -1){
			categoria = categorias[params.categoria];
		}
		if (params.id && params.id != "agregar"){
			elm = $docs.filter((el)=>el._id == params.id)[0];
			if (elm.tipo == "Producto"){
				nombre = elm.nombre;
				costo = elm.costo;
				precio = elm.precio;
				alerta = elm.alerta;
				categoria = elm.categoria;
			} else {
				nombre = elm.nombre;
			}
		}
		if (!$logueo){
			replace('/');
		}
	})
</script>
<Controlador bind:this={c} />
<div class="w-full p-4 flex flex-col items-center justify-start">
	<a href={`#/deposito/${(params.categoria==-1?"-1":params.categoria)}`} class="w-full rounded bg-red-500 text-white shadow m-2 p-2">
		<i class="ri-arrow-left-line" />
		Volver
	</a>
	<div class="w-full flex items-center rounded shadow m-2 overflow-hidden">
		<div on:click={prod} class={(tipo == 0? clase[0] : clase[1])}>
			Producto
		</div>
		<div on:click={serv} class={(tipo == 1? clase[0]:clase[1])}>
			Servicio
		</div>
	</div>
	<input bind:value={nombre} type="text" placeholder="Nombre" class="w-full p-2 m-2 bg-white rounded shadow" />
	{#if tipo == 0}
				<input bind:value={precio} type="tel" placeholder="Precio" class="w-full p-2 m-2 bg-white rounded shadow" />
		<select class="w-full p-2 m-2 bg-white runded shadow" bind:value={categoria}>
			<option selected={categoria == ""} value="">Elegir Categoria</option>
			{#each categorias as cat}
				<option selected={categoria == cat} value={cat}>{cat}</option>
			{/each}
		</select>
		<div class="w-full flex items-center rounded shadow m-2 overflow-hidden">
			<div on:click={sinAlerta} class={(alerta == 0? clase[0] : clase[1])}>
				Sin alerta de stock
			</div>
			<div on:click={conAlerta} class={(alerta == 1? clase[0]:clase[1])}>
				Con alerta de stock
			</div>
		</div>
	{/if}
	{#if ((nombre != "" && tipo == 1) || (nombre != "" && precio && tipo == 0))}
		<button on:click={agregar} class="w-full m-2 p-2 bg-red-500 text-white cursor-pointer rounded shadow hover:bg-red-300">
			<i class="ri-add-line" />
			{(params.id != "agregar"?"Editar":"Agregar")}
		</button>
	{/if}
</div>
